import{jsx as n}from"react/jsx-runtime";import{Spinner as o}from"@platform/ui";const e=({className:i,...r})=>n(o,{...r});export{e as UiSpinner};
//# sourceMappingURL=UiSpinner.js.map
